import React, { useCallback, useState } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core/hooks';

import ListPlaceholder from '../ListPlaceholder';

import { CategoryCardContainer } from './widgets/CategoryCard';
import { ServiceModalContainer } from './widgets/ServiceModal';
import { CategoriesTable, ServicesHeader } from './components';
import { useGetCategoriesQuery } from './queries';

interface Props {
  isPageMode?: boolean;
}

const ServicesContainer: React.FC<Props> = ({ isPageMode }) => {
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const { categories, isLoading } = useGetCategoriesQuery();

  const isCreateAccessible = useHasAccess([
    { permission: Permissions.MANAGE_SERVICES },
    { permission: Permissions.SET_UP_PROCESSING_DEFINITION },
  ]);

  const handleCreateService = useCallback(() => {
    setIsCreateModalVisible(true);
  }, []);

  const handleCloseCreateModal = useCallback(() => {
    setIsCreateModalVisible(false);
  }, []);

  if (isLoading) {
    return (
      <Box pad={{ top: 'spacing24' }}>
        <Preloader testId="services_loading" />
      </Box>
    );
  }

  return (
    <Box data-testid="services_wrapper" direction="column" width="100%" style={{ flex: 'none' }}>
      <ServicesHeader
        isPageMode={isPageMode}
        isCreateAccessible={isCreateAccessible}
        onCreateService={handleCreateService}
      />
      {categories.length === 0 ? (
        <ListPlaceholder testId="services">There are no Services</ListPlaceholder>
      ) : (
        <CategoriesTable>
          {categories.map((category) => (
            <CategoryCardContainer key={category.id} category={category} />
          ))}
        </CategoriesTable>
      )}
      <ServiceModalContainer visible={isCreateModalVisible} onClose={handleCloseCreateModal} />
    </Box>
  );
};

export default ServicesContainer;
